namespace TabAurous.HR {
    export interface PayrollDetailsForm {
        EmployeeName: Serenity.StringEditor;
        EmployeeCode: Serenity.StringEditor;
        NetSalary: Serenity.DecimalEditor;
        GrossSalary: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        Present: Serenity.IntegerEditor;
        Absent: Serenity.IntegerEditor;
        HalfDay: Serenity.IntegerEditor;
        OnLeave: Serenity.IntegerEditor;
        EmployeeDetails: PayrollEarningsEditor;
        Earnings: PayrollEarningsEditor;
        Deductions: PayrollDeductionsEditor;
    }

    export class PayrollDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'HR.PayrollDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PayrollDetailsForm.init)  {
                PayrollDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.IntegerEditor;
                var w3 = PayrollEarningsEditor;
                var w4 = PayrollDeductionsEditor;

                Q.initFormType(PayrollDetailsForm, [
                    'EmployeeName', w0,
                    'EmployeeCode', w0,
                    'NetSalary', w1,
                    'GrossSalary', w1,
                    'TaxAmount', w1,
                    'Present', w2,
                    'Absent', w2,
                    'HalfDay', w2,
                    'OnLeave', w2,
                    'EmployeeDetails', w3,
                    'Earnings', w3,
                    'Deductions', w4
                ]);
            }
        }
    }
}
